// extracted by mini-css-extract-plugin
export var container = "TitleArea-module--container--ynsqt";
export var content = "TitleArea-module--content--LEmUf";